import React from "react";
import "./DashboardMain.scss";
import DashChart from "./DashChart";

const DashboardMain = ({ setActiveTab, setFullWidth }) => {
  return (
    <div className="dashboardMain customScroller-transparent">
      <h3>Dashboard</h3>
      {/* <h3>Social Media Accounts Activities</h3> */}

      <div className="dashboardMain-socialMediaStats-container">
        <div
          className="dashboardMain-socialMediaStats-box"
          onClick={() => {
            setActiveTab("analyzebrand");
            setFullWidth(false);
          }}
        >
          <h5>Analyze Brand</h5>
          {/* <ul>
            <li>
              <span>Likes</span>
              <span>3,200</span>
            </li>
            <li>
              <span>Comments</span>
              <span>1102</span>
            </li>
            <li>
              <span>Followers</span>
              <span>5902</span>
            </li>
            <li>
              <span>Mentions</span>
              <span>74</span>
            </li>
          </ul> */}
        </div>
        <div
          className="dashboardMain-socialMediaStats-box"
          onClick={() => {
            setActiveTab("review");
            setFullWidth(false);
          }}
        >
          <h5>Brand Review</h5>
          {/* <ul>
            <li>
              <span>Likes</span>
              <span>2,200</span>
            </li>
            <li>
              <span>Comments</span>
              <span>1202</span>
            </li>
            <li>
              <span>Followers</span>
              <span>5606</span>
            </li>
            <li>
              <span>Mentions</span>
              <span>44</span>
            </li>
          </ul> */}
        </div>
        <div
          className="dashboardMain-socialMediaStats-box"
          onClick={() => {
            setActiveTab("product");
            setFullWidth(false);
          }}
        >
          <h5>Product Review</h5>
          {/* <ul>
            <li>
              <span>Likes</span>
              <span>4,200</span>
            </li>
            <li>
              <span>Comments</span>
              <span>632</span>
            </li>
            <li>
              <span>Followers</span>
              <span>4702</span>
            </li>
            <li>
              <span>Mentions</span>
              <span>65</span>
            </li>
          </ul> */}
        </div>
        <div
          className="dashboardMain-socialMediaStats-box"
          onClick={() => {
            setActiveTab("brandcomparison");
            setFullWidth(false);
          }}
        >
          <h5>Brand Comparison</h5>
          {/* <ul>
            <li>
              <span>Likes</span>
              <span>1,200</span>
            </li>
            <li>
              <span>Comments</span>
              <span>607</span>
            </li>
            <li>
              <span>Followers</span>
              <span>5002</span>
            </li>
            <li>
              <span>Mentions</span>
              <span>29</span>
            </li>
          </ul> */}
        </div>
      </div>
      {/* 
            <div className='dashboardMain-socialMediaStats-graph-container'>
                <div className='dashboardMain-socialMediaStats-graph-box'>
                    <h5>Website Analytics</h5>
                    <DashChart />
                </div>
                <div className='dashboardMain-socialMediaStats-graph-txt-box'>
                    <h5>Reach and Impressions</h5>
                    <div className='dashboardMain-socialMediaStats-graph-txtReach-box'>
                        <h6 className='pt-2'>Reach</h6>
                        <div className='reach-div'>
                            <p>Total Visitors</p>
                            <p>
                                408
                                <span>90.3%</span>
                            </p>
                        </div>
                        <div className='reach-div'>
                            <p>Total Click</p>
                            <p>
                                8,092
                                <span>71.2%</span>
                            </p>
                        </div>
                        <div className='reach-div'>
                            <p>Post Likes</p>
                            <p>
                                4,410
                                <span>51.7%</span>
                            </p>
                        </div>

                        <h6 className='pt-2'>Impressions</h6>
                        <div className='reach-div'>
                            <p>Video Views</p>
                            <p>
                                6,909
                                <span>90.3%</span>
                            </p>
                        </div>
                        <div className='reach-div'>
                            <p>Post Impressions</p>
                            <p>
                                2,373
                                <span>71.2%</span>
                            </p>
                        </div>
                        <div className='reach-div'>
                            <p>Engagements</p>
                            <p>
                                2,100
                                <span>51.7%</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div> */}
    </div>
  );
};

export default DashboardMain;
